import { Table, Button, InputNumber, Select, Divider } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import React, { useEffect } from 'react';

const { Option } = Select;

const MovementItemsTable = ({ movementItems, setMovementItems, costCenters, planCuentas }) => {
  const addMovementItem = () => {
    const newItem = {
      key: Date.now(), // Usar timestamp para evitar colisiones de keys
      amount: 0,
      type: 'INGRESO',
      costCenter: null,
      planCuentas: null
    };
    setMovementItems([...movementItems, newItem]);
  };

  const removeMovementItem = (key) => {
    const updatedItems = movementItems.filter(item => item.key !== key);
    setMovementItems(updatedItems);
  };

  const handleMovementItemChange = (key, field, value) => {
    const updatedItems = movementItems.map(item => {
      if (item.key === key) {
        return { ...item, [field]: value };
      }
      return item;
    });
    setMovementItems(updatedItems);
  };

  const columns = [
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
      width:'30%',
      render: (_, record) => (
        <InputNumber
          style={{ width: '100%' }}
          value={record.amount}
          onChange={(value) => handleMovementItemChange(record.key, 'amount', value)}
          min={0}
        />
      ),
    },
    {
      title: 'Cuenta',
      dataIndex: 'planCuentas',
      key: 'planCuentas',
      width:'30%',
      render: (_, record) => (
        <Select
          style={{ width: '100%' }}
          value={record.planCuentas}
          onChange={(value) => handleMovementItemChange(record.key, 'planCuentas', value)}
          showSearch
          filterOption={(input, option) => {
            // Obtenemos el nombre de la cuenta a partir del option.label
            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}
        >
          {planCuentas.map((cuenta) => (
            <Option 
              key={cuenta.pla_id} 
              value={cuenta.pla_id}
              label={cuenta.pla_nombre} // Agregamos el nombre como label para la búsqueda
            >
              {cuenta.pla_nivel === 1 ? (
                <strong>{cuenta.pla_nombre}</strong>
              ) : (
                cuenta.pla_nombre
              )}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: 'Centro de Costo',
      dataIndex: 'costCenter',
      key: 'costCenter',
      width:'30%',
      render: (_, record) => (
        <Select
          style={{ width: '100%' }}
          value={record.costCenter}
          onChange={(value) => handleMovementItemChange(record.key, 'costCenter', value)}
        >
          {costCenters.map((center) => (
            <Option key={center.cen_id} value={center.cen_id}>
              {center.cen_nombre}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      width: '10%',
      render: (_, record) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => removeMovementItem(record.key)}
            disabled={movementItems.length === 1}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <Divider orientation="left">Detalle de Movimientos</Divider>

      <Table
        dataSource={movementItems}
        columns={columns}
        pagination={false}
        rowKey="key"
      />

      <Button
        type="dashed"
        onClick={addMovementItem}
        style={{ width: '100%', marginTop: 16, marginBottom: 16 }}
        icon={<PlusOutlined />}
      >
        Agregar Movimiento
      </Button>
    </>
  );
};

export default MovementItemsTable;